export default {
  props: {
    date: { type: Date, required: true },
    path: { type: String, required: true },
  },
  computed: {
    day() {
      return this.date.getDate();
    },
    weekday() {
      return this.date.getDay();
    },
    month() {
      return this.date.getMonth() + 1;
    },
    year() {
      return this.date.getFullYear();
    },
    minutes() {
      return this.date.getMinutes();
    },
    hours() {
      return this.date.getHours();
    },
  },
};
